import React from "react";

import { colors } from "@zapalacorp/tokens";

import IconCheck from "../../../../../../../components/Generic/Icons/Check";
import { ButtonContainer, ButtonContent } from "./style";

type ButtonOption = {
  key: string | number;

  label: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
};

type Props = {
  buttons: Array<ButtonOption>;
  activeKey: ButtonOption["key"];
};

export const ButtonGroup: React.FC<Props> = (props) => {
  const { buttons, activeKey } = props;

  return (
    <ButtonContainer>
      {buttons.map((button, index) => {
        const isActive = activeKey === button.key;

        return (
          <ButtonContent
            key={button.key}
            onClick={button.onClick}
            isActive={isActive}
            isFirst={index === 0}
            isLast={index + 1 === buttons.length}
          >
            {isActive && <IconCheck color={colors.brandBlue500} width={20} height={20} />}
            <span>{button.label}</span>
          </ButtonContent>
        );
      })}
    </ButtonContainer>
  );
};
